import React from 'react';
import { ColumnsV2, Flex, IconV2, TextV2, Toggle, TooltipV2 } from '@withjoy/joykit';
import { ReactComponent as DelayShippingIcon } from '../../assets/delay-ship-24.svg';
import { ReactComponent as HelpIcon } from '../../assets/help.svg';
import { useDelayShippingContext } from './DelayShipping.context';
import { SkeletonText } from '@shared/components/Skeleton';
import { pxToRem } from '@withjoy/joykit/theme';
import { useTranslation } from '@shared/core';
import { useDelayShippingTelemetry } from './DelayShipping.telemetry';

export const DelayShippingToggle = () => {
  const { t } = useTranslation('yourRegistry');
  const { tooltipDescription, toggleLabel } = t('delayShipping');
  const { isDelayShippingEnabled, onOpenConfirmationDialog, loadingDelayOrderFulfillment } = useDelayShippingContext();
  const telemetry = useDelayShippingTelemetry();
  return !loadingDelayOrderFulfillment ? (
    <Flex alignItems="center" justifyContent="space-between" width="100%">
      <Flex flex={0.8}>
        <Flex alignItems="center">
          <IconV2 marginRight={1}>
            <DelayShippingIcon />
          </IconV2>
          <TextV2 typographyVariant="hed2" color="mono14">
            {toggleLabel()} {isDelayShippingEnabled ? 'On' : 'Off'}
          </TextV2>
          <TooltipV2 placement="bottom" showArrow={true} content={<TextV2 width="250px">{tooltipDescription()}</TextV2>}>
            <IconV2 marginLeft={1} marginTop={2}>
              <HelpIcon />
            </IconV2>
          </TooltipV2>
        </Flex>
      </Flex>
      <Flex flex={0.2}>
        <Flex justifyContent="flex-end">
          <Toggle
            label=""
            hideLabel={true}
            checked={isDelayShippingEnabled}
            name="enableDelayShipping"
            onClick={() => {
              telemetry.toggleDelayShippingClicked();
              onOpenConfirmationDialog();
            }}
            readOnly
          />
        </Flex>
      </Flex>
    </Flex>
  ) : (
    <ColumnsV2>
      <SkeletonText rows={1} width={pxToRem(300)} skeletonHeight={pxToRem(26)} />
    </ColumnsV2>
  );
};
